import { IGigPayoutsUpload } from "store/wh-partner-services/whPartnerServicesSlice";

const PERSIST_KEY = "wh_partner_gig_payouts_processing";

export const persistWhProcessingGigPayouts = (data: IGigPayoutsUpload) => {
  try {
    localStorage.setItem(PERSIST_KEY, JSON.stringify(data));
  } catch (error) {
    console.error("Error persisting WH Gig Payouts data:", error);
  }
};

export const getPersistedWhProcessingGigPayouts = (): IGigPayoutsUpload => {
  try {
    const data = localStorage.getItem(PERSIST_KEY);
    return data ? JSON.parse(data) : {};
  } catch (error) {
    console.error("Error retrieving WH Gig Payouts data:", error);
    return {};
  }
};

export const removePersistedWhProcessingGigPayouts = () => {
  try {
    localStorage.removeItem(PERSIST_KEY);
  } catch (error) {
    console.error("Error removing WH Gig Payouts data:", error);
  }
};
